import { erAngittVarighetInnenforPeriode, garanterListe, ledetekst } from '..';
import { Soknad } from '../domene/Soknad';

export function validerVegarbeidperiode(soknad: Soknad) {
	const vegarbeidperiode = soknad?.vegarbeid?.vegarbeidsperiode;
	const harFra = vegarbeidperiode?.fra;
	const harTil = vegarbeidperiode?.til;
	const harArbeidsvarighet =
		vegarbeidperiode?.arbeidsvarighet &&
		vegarbeidperiode?.arbeidsvarighet?.periodisering &&
		vegarbeidperiode?.arbeidsvarighet?.varighet;
	const harTypeDager = vegarbeidperiode?.typeDager;
	const varighetInnenforPeriode =
		erAngittVarighetInnenforPeriode(vegarbeidperiode);
	const harArbeidstidsperioder =
		garanterListe(vegarbeidperiode?.arbeidstidsperioder).length > 0;

	if (
		harFra &&
		harTil &&
		harArbeidsvarighet &&
		harTypeDager &&
		varighetInnenforPeriode &&
		harArbeidstidsperioder
	) {
		return '';
	}

	if (!varighetInnenforPeriode) {
		return ledetekst.getTekst(
			'arbeidsvarsling.soknad.Vegarbeidperiode.varighetIkkeInnenforPeriode'
		);
	}

	return ledetekst.getTekst(
		'arbeidsvarsling.soknad.Oppsummering.ufullstendig.vegarbeidperiode'
	);
}
